import React, { useContext, useEffect, useRef, useState } from 'react';
import { CompanyModuleEnum, LovDTO } from '@api/ringil-api.v2.tsx';
import { ApiContext } from '@api/api.tsx';
import { MultiSelect } from 'primereact/multiselect';
import { deferStampDataTestIdOnDescendantRef, toTestIdSlug } from '@utils/testUtils';

interface ComponentProps {
  values: LovDTO[];
  onChange: (values: LovDTO[]) => void;
  placeholder?: string;
  dataTestId?: string;
}

const InputCustomDeclarant: React.FC<ComponentProps> = ({ values, onChange, placeholder, dataTestId }) => {

  const [companies, setCompanies] = useState([]);
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  const { lovAllCompaniesByInheritModule } = useContext(ApiContext); // LovDTO

  useEffect(() => {
    return deferStampDataTestIdOnDescendantRef(wrapperRef, '.p-multiselect', dataTestId);
  }, [dataTestId, companies]);

  useEffect(() => {
    lovAllCompaniesByInheritModule(
      CompanyModuleEnum.CUSTOMS_DECLARATION,
      data => setCompanies(data.filter(company => company.active)));
  }, []);
  return (
    <div ref={wrapperRef}>
      <MultiSelect
        value={values}
        options={companies}
        optionLabel="name"
        filter
        onChange={e => onChange(e.value)}
        placeholder={placeholder}
        panelClassName={dataTestId}
        itemTemplate={(option: LovDTO) => (
          <div data-testid={dataTestId ? `${dataTestId}-${toTestIdSlug(option.name)}` : undefined}>
            {option.name}
          </div>
        )}
      />
    </div>
  );
};

export default InputCustomDeclarant;
